import { IsBoolean, IsDefined, IsIn, IsOptional, IsString } from 'class-validator';
import { TransformBoolean } from '../../custom-validation';
import { BankingDepositStatusEnum } from '../../enum/banking/banking-deposit-status.enum';

export class BankingDepositSearchDto {
  @IsDefined()
  merchantIds: number[];

  @IsOptional()
  @TransformBoolean()
  @IsBoolean()
  isHeadOffice?: boolean;

  @IsOptional()
  @IsString()
  @IsIn(Object.values(BankingDepositStatusEnum))
  status?: BankingDepositStatusEnum;
}
